import { useFlags } from 'launchdarkly-react-client-sdk';

export interface FeatureFlags {
    ldFlagLandDevelopment: boolean;
    ldFlagUploadedProForma: boolean;
}

export const useTypedFlags = (): FeatureFlags => useFlags<FeatureFlags>();
